import PropTypes from "prop-types";
import ResetScopeDialog from "./ResetScopeDialog";
export default function ResetCommerceReadersDialog({
  open,
  onClose,
  onConfirm,
  commerceName = "",
  getCommerceReaders = () => [],
  resetCommerceLoading = false,
}) {
  return (
    <ResetScopeDialog
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm(commerceName)}
      title="Reiniciar readers del comercio"
      scope={commerceName || "Comercio no seleccionado"}
      readers={getCommerceReaders(commerceName) || []}
      loading={resetCommerceLoading}
    />
  );
}
ResetCommerceReadersDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  commerceName: PropTypes.string,
  getCommerceReaders: PropTypes.func,
  resetCommerceLoading: PropTypes.bool,
};
